import { actionTrackApi } from "@/apis/common.api"
import store from "@/store";
import { storeGet } from "@/utils/localStore"
// (please consult doc)[https://d9pqpqvtzu.feishu.cn/wiki/Z422wJ9FxigeGVkXcL6ct1rBnZe]
export const EVENT_TYPE_ENUM = {
  // 签到活动
  wechat_sign_activity_home: 'wechat_sign_activity_home',
  wechat_sign_activity_rule_button: 'wechat_sign_activity_rule_button',
  wechat_sign_activity_first_visit_pop: 'wechat_sign_activity_first_visit_pop',
  wechat_sign_activity_first_visit_pop_to_sign: 'wechat_sign_activity_first_visit_pop_to_sign',
  wechat_sign_activity_not_sign_pop: 'wechat_sign_activity_not_sign_pop',
  wechat_sign_activity_one_key_sign_button: 'wechat_sign_activity_one_key_sign_button',
  wechat_sign_activity_sign_button: 'wechat_sign_activity_sign_button',
  wechat_sign_activity_draw_gift_button: 'wechat_sign_activity_draw_gift_button',
  wechat_sign_activity_draw_gift_success_pop: 'wechat_sign_activity_draw_gift_success_pop',
  wechat_sign_activity_know_button: 'wechat_sign_activity_know_button',
  wechat_sign_activity_copy_cdk_button: 'wechat_sign_activity_copy_cdk_button',
  wechat_sign_activity_rule_pop: 'wechat_sign_activity_rule_pop',
  wechat_sign_activity_advertise: 'wechat_sign_activity_advertise',
  // 礼包中心
  wechat_gift_center_page: 'wechat_gift_center_page',
  wechat_gift_center_draw_gift_button: 'wechat_gift_center_draw_gift_button',
  wechat_gift_center_not_bind_user_pop: 'wechat_gift_center_not_bind_user_pop',
  wechat_gift_center_know_button: 'wechat_gift_center_know_button',
  wechat_gift_center_draw_gift_success_pop: 'wechat_gift_center_draw_gift_success_pop',
  wechat_gift_center_see_button: 'wechat_gift_center_see_button',
  wechat_gift_center_copy_cdk_button: 'wechat_gift_center_copy_cdk_button',
  // 我的礼包
  wechat_mine_gift_page: 'wechat_mine_gift_page',
  wechat_mine_gift_tab_button: 'wechat_mine_gift_tab_button',
  wechat_mine_gift_copy_button: 'wechat_mine_gift_copy_button',
  // 游戏中心
  wechat_game_center_page: 'wechat_game_center_page',
  wechat_game_center_not_bind_user_pop: 'wechat_game_center_not_bind_user_pop',
  wechat_game_center_know_button: 'wechat_game_center_know_button',
  wechat_game_center_one_key_play_button: 'wechat_game_center_one_key_play_button',
  wechat_game_center_banner: 'wechat_game_center_banner',
  // 累充活动
  wechat_pay_activity_home: 'wechat_pay_activity_home',
  wechat_pay_activity_rule_button: 'wechat_pay_activity_rule_button',
  wechat_pay_activity_not_bin_user_pop: 'wechat_pay_activity_not_bin_user_pop',
  wechat_pay_activity_know_button: 'wechat_pay_activity_know_button',
  wechat_pay_activity_rule_pop: 'wechat_pay_activity_rule_pop',
  wechat_pay_activity_gift_wait_draw_button: 'wechat_pay_activity_gift_wait_draw_button',
  wechat_pay_activity_gift_wait_unlock_button: 'wechat_pay_activity_gift_wait_unlock_button',
  wechat_pay_activity_draw_gift_success_pop: 'wechat_pay_activity_draw_gift_success_pop',
  wechat_pay_activity_see_button: 'wechat_pay_activity_see_button',
  wechat_pay_activity_copy_cdk_button: 'wechat_pay_activity_copy_cdk_button',
  wechat_pay_activity_draw_not_complete_pop: 'wechat_pay_activity_draw_not_complete_pop',
  // 角色绑定
  wechat_role_bind_page: 'wechat_role_bind_page',
  wechat_role_info_pop: 'wechat_role_info_pop',
  wechat_role_info_bind_button: 'wechat_role_info_bind_button',
  wechat_role_to_gift_button: 'wechat_role_to_gift_button',

  // 企微活动链接 -- 活动已结束
  enterprise_wx_h5_page_end: 'enterprise_wx_h5_page_end',
  // 企微活动链接 -- 活动生效中
  enterprise_wx_h5_page_underway: 'enterprise_wx_h5_page_underway',
  // 企微活动链接 -- 礼包码奖励
  enterprise_wx_h5_page_receive_award: 'enterprise_wx_h5_page_receive_award',
  // 企微活动链接 -- 领取不满足领取条件弹窗
  enterprise_wx_h5_dissatisfy_draw_pop: 'enterprise_wx_h5_dissatisfy_draw_pop',
  // 企微活动链接 -- 领取礼包点击
  enterprise_wx_h5_page_draw_button: 'enterprise_wx_h5_page_draw_button',
  // 企微小游戏转游活动 -- 一键开玩按钮
  enterprise_wx_h5_one_key_play_button: 'enterprise_wx_h5_one_key_play_button',
  // 企微小游戏转游活动 -- 邮件奖励
  enterprise_wx_h5_mail_reward: 'enterprise_wx_h5_mail_reward',

  // 促单活动
  wechat_promote_page: 'wechat_promote_page', 
  wechat_promote_bind_role_button: 'wechat_promote_bind_role_button', 
  wechat_promote_cut_role_button: 'wechat_promote_cut_role_button', 
  wechat_promote_button: 'wechat_promote_button', 
  wechat_promote_apply_button: 'wechat_promote_apply_button', 
  wechat_promote_draw_button: 'wechat_promote_draw_button', 
  wechat_promote_draw_not_complete_pop: 'wechat_promote_draw_not_complete_pop', 
  wechat_promote_draw_ack_pop: 'wechat_promote_draw_ack_pop', 
  wechat_promote_draw_reward_button: 'wechat_promote_draw_reward_button', 
  wechat_promote_draw_success_pop: 'wechat_promote_draw_success_pop', 
  wechat_promote_role_bind_page: 'wechat_promote_role_bind_page', 
  wechat_promote_ask_bind_pop: 'wechat_promote_ask_bind_pop', 
  wechat_promote_ask_bind_button: 'wechat_promote_ask_bind_button', 
  wechat_promote_complete_bind_button: 'wechat_promote_complete_bind_button',

  // 转盘抽奖
  wechat_promote_wheel_draw_button: 'wechat_promote_wheel_draw_button',
  wechat_promote_wheel_draw_success_pop: 'wechat_promote_wheel_draw_success_pop',
  wechat_promote_wheel_draw_task_button: 'wechat_promote_wheel_draw_task_button',
  wechat_promote_wheel_dissatisfy_draw_pop: 'wechat_promote_wheel_dissatisfy_draw_pop',
  wechat_promote_wheel_position_info: 'wechat_promote_wheel_position_info',

  // 企微转游促单活动
  wechat_enterprise_promote_page: 'wechat_enterprise_promote_page',
  wechat_enterprise_promote_bind_role_button: 'wechat_enterprise_promote_bind_role_button',
  wechat_enterprise_promote_cut_role_button: 'wechat_enterprise_promote_cut_role_button',
  wechat_enterprise_promote_button: 'wechat_enterprise_promote_button',
  wechat_enterprise_promote_play_button: 'wechat_enterprise_promote_play_button',
  wechat_enterprise_promote_to_complete_button: 'wechat_enterprise_promote_to_complete_button',
  wechat_enterprise_promote_draw_button: 'wechat_enterprise_promote_draw_button',
  wechat_enterprise_promote_draw_not_complete_pop: 'wechat_enterprise_promote_draw_not_complete_pop',
  wechat_enterprise_promote_draw_success_pop: 'wechat_enterprise_promote_draw_success_pop',
  wechat_enterprise_promote_role_bind_page: 'wechat_enterprise_promote_role_bind_page',
  wechat_enterprise_promote_ask_bind_pop: 'wechat_enterprise_promote_ask_bind_pop',
  wechat_enterprise_promote_ask_bind_button: 'wechat_enterprise_promote_ask_bind_button',  
  wechat_enterprise_promote_complete_bind_button: 'wechat_enterprise_promote_complete_bind_button',  

  // 企微召回后维护
  enterprise_wx_h5_cut_role_button: 'enterprise_wx_h5_cut_role_button',
  enterprise_wx_h5_draw_info_button: 'enterprise_wx_h5_draw_info_button',
  enterprise_wx_h5_rule_button: 'enterprise_wx_h5_rule_button',
  enterprise_wx_h5_cut_role_pop: 'enterprise_wx_h5_cut_role_pop',
  enterprise_wx_h5_cut_role_affirm_button: 'enterprise_wx_h5_cut_role_affirm_button',
  enterprise_wx_h5_many_gift_task_tip_pop: 'enterprise_wx_h5_many_gift_task_tip_pop',
  enterprise_wx_h5_many_gift_reward_pop: 'enterprise_wx_h5_many_gift_reward_pop',
  enterprise_wx_h5_many_gift_draw_button: 'enterprise_wx_h5_many_gift_draw_button',
}

export default {
  data () {
    return {
      referer_path: '', // 上页面路径
      referer_name: '' // 上页面名称
    }
  },
  // 路由拦截
  beforeRouteEnter (to, from, next) {
    next(vm => {
      vm.referer_name = from.meta ? from.meta.title : from.name
      vm.referer_path = from.fullPath
    })
  },
  methods: {
    EVENT_TRACKING (event_name, params = "", extra = {}) {
      if (!event_name) {
        return console.error('事件名不能为空')
      }
  
      actionTrackApi({
        platform: 'WeiXin',
        wxappid: storeGet('WX_APP_ID'),
        openid: store.getters['user/openid'],
        event: event_name,
        event_field: params ? JSON.stringify(params) : '',
        userId: store.getters['user/uid'],
        ip_addr: storeGet('IP_ADDR'),
        ...extra,
      })
    },
  },
}
